import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cgv',
  templateUrl: './cgv.component.html',
  styleUrls: ['./cgv.component.scss'],
})
export class CgvComponent implements OnInit {

  email : string = "Coachcompanion95@gmail.com";

  constructor(private readonly router: Router) { }

  ngOnInit() {}

  backClick() {
    this.router.navigateByUrl("/coach/about");
  }

}
